import { Dispatchernurlbopdkn3a as Dispatcher } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/SpinCommand.mjs';
import { Dispatcher2jh9je6zwmtr7 as Dispatcher_0 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/party/DeletePartyCommand.mjs';
import { Dispatcher2k7js8ct0qtp5 as Dispatcher_1 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/pairassignmentdocument/DeletePairAssignmentsCommand.mjs';
import { Dispatcher39hthxqv8voqz as Dispatcher_2 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/player/SavePlayerCommand.mjs';
import { Dispatchervu4hb3oerxrm as Dispatcher_3 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/GrantSlackAccessCommand.mjs';
import { Dispatcher3f3rv68jjbf7x as Dispatcher_4 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/secret/CreateSecretCommand.mjs';
import { Dispatcher1dgi8c7arrsv1 as Dispatcher_5 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/player/DeletePlayerCommand.mjs';
import { Dispatcher2txct93ff9b99 as Dispatcher_6 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/pin/DeletePinCommand.mjs';
import { Dispatcher2xvjdz9qh940 as Dispatcher_7 } from '../../../../../Coupling-sdk/com/zegreatrob/coupling/sdk/gql/GqlQuery.mjs';
import { Dispatcher396y2mcz9r128 as Dispatcher_8 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/party/SavePartyCommand.mjs';
import { Dispatcherb76d0p5pxiow as Dispatcher_9 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/pin/SavePinCommand.mjs';
import { Dispatcher3r3trxa1ofgr6 as Dispatcher_10 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/secret/DeleteSecretCommand.mjs';
import { Dispatchernmy2not8m2c7 as Dispatcher_11 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/pairassignmentdocument/SavePairAssignmentsCommand.mjs';
import { Dispatcher27uwezb7p8fpg as Dispatcher_12 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/GrantDiscordAccessCommand.mjs';
import { Dispatcher3ngwv5mtnm33a as Dispatcher_13 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/ApplyBoostCommand.mjs';
import { Dispatcher3kdydho2ojhnk as Dispatcher_14 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/party/SaveSlackIntegrationCommand.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ClientDispatcherClass;
function ClientDispatcher() {
  if (ClientDispatcherClass === VOID) {
    class $ {
      constructor(sdkDispatcher) {
        this.q7w_1 = sdkDispatcher;
      }
      *n2h(command, $completion) {
        return yield* this.q7w_1.n2h(command, $completion);
      }
      *j2j(command, $completion) {
        return yield* this.q7w_1.j2j(command, $completion);
      }
      *f2i(command, $completion) {
        return yield* this.q7w_1.f2i(command, $completion);
      }
      *o2i(command, $completion) {
        return yield* this.q7w_1.o2i(command, $completion);
      }
      *x2i(command, $completion) {
        return yield* this.q7w_1.x2i(command, $completion);
      }
      *d2j(command, $completion) {
        return yield* this.q7w_1.d2j(command, $completion);
      }
      *m2j(command, $completion) {
        return yield* this.q7w_1.m2j(command, $completion);
      }
      *q2h(command, $completion) {
        return yield* this.q7w_1.q2h(command, $completion);
      }
      *t2h(command, $completion) {
        return yield* this.q7w_1.t2h(command, $completion);
      }
      *x75(query, $completion) {
        return yield* this.q7w_1.x75(query, $completion);
      }
      *l2i(command, $completion) {
        return yield* this.q7w_1.l2i(command, $completion);
      }
      *r2i(command, $completion) {
        return yield* this.q7w_1.r2i(command, $completion);
      }
      *a2j(command, $completion) {
        return yield* this.q7w_1.a2j(command, $completion);
      }
      *g2j(command, $completion) {
        return yield* this.q7w_1.g2j(command, $completion);
      }
      *u2i(command, $completion) {
        return yield* this.q7w_1.u2i(command, $completion);
      }
      *w2h(command, $completion) {
        return yield* this.q7w_1.w2h(command, $completion);
      }
    }
    initMetadataForClass($, 'ClientDispatcher', VOID, VOID, [Dispatcher(), Dispatcher_0(), Dispatcher_1(), Dispatcher_2(), Dispatcher_3(), Dispatcher_4(), Dispatcher_5(), Dispatcher_6(), Dispatcher_7(), Dispatcher_8(), Dispatcher_9(), Dispatcher_10(), Dispatcher_11(), Dispatcher_12(), Dispatcher_13(), Dispatcher_14()], [1]);
    ClientDispatcherClass = $;
  }
  return ClientDispatcherClass;
}
//region block: exports
export {
  ClientDispatcher as ClientDispatcher1p2vginamq4dq,
};
//endregion

//# sourceMappingURL=ClientDispatcher.mjs.map
